// extracted by mini-css-extract-plugin
export default {"warningText":"PageButtons_warningText__Jkzl8","statusPending":"PageButtons_statusPending__CfIrI","bold":"PageButtons_bold__nWiyL"};